import { StatePropertyRef, StatePropertyRef2 } from '../../canvas/ExtendableStore';

export type ManualSpotlightTarget = readonly [number, number, number];

export interface ManualSpotlightInfo {
    enabled: boolean;
    target: ManualSpotlightTarget;
}

export const ManualSpotlightInfo = StatePropertyRef<ManualSpotlightInfo>(
    'manualSpotlight', { enabled: false, target: [0, 0, 0] }
);

export const CreateManualSpotlight = (enabled: boolean, target: ManualSpotlightTarget = [0, 0, 0]) =>
    ({ enabled, target }) as ManualSpotlightInfo;


export type AutoSpotlightMode = 'objects' | 'votes';
export interface AutoSpotlightInfo {
    enabled: boolean;
    target: string;
    mode: AutoSpotlightMode;
}

const CreateAutoSpotlight = (enabled: boolean, target: string = '', mode: AutoSpotlightMode = 'objects') =>
    ({ enabled, target, mode }) as AutoSpotlightInfo;

export const AutoSpotlightInfo = StatePropertyRef2(
    'test',
    CreateAutoSpotlight,
    CreateAutoSpotlight(false),
);
